import { useTranslation } from 'react-i18next';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FurnitureSettings = () => {
  const { t } = useTranslation();

  return (
    <Accordion type="single" className="w-full overflow-hidden rounded-sm bg-[#EFF4F5]" collapsible>
      <AccordionItem value="room-mode-settings">
        <AccordionTrigger className="flex h-[40px] w-full cursor-pointer items-center rounded-b-sm px-4">
          <span className="flex-1 text-left text-sm font-semibold">{t('furniture')}</span>
        </AccordionTrigger>
        <AccordionContent className="px-4 py-3">{t('children')}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
